import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SidePanel } from '../ui';
import ControlPage from '../../pages/controls/ControlPage';

export default function ControlOverlay({ open, onClose, control_id }) {
    const defaultWidth = useMemo(() => Math.round(window.innerWidth * 0.6), []);
    const [renderId, setRenderId] = useState(null);

    useEffect(() => {
        if (open && control_id != null) {
            setRenderId(control_id);
        }
    }, [open, control_id]);

    const handleClosed = useCallback(() => {
        setRenderId(null);
    }, []);

    if (renderId == null && !open) return null;

    return (
        <SidePanel
            open={open}
            onClose={onClose}
            onClosed={handleClosed}
            overlayZIndex="z-[400]"
            resizable
            defaultWidth={defaultWidth}
            minWidth={420}
            className="rounded-tl-2xl"
        >
            {renderId != null && (
                <ControlPage
                    embedded
                    embeddedId={renderId}
                    onClose={onClose}
                />
            )}
        </SidePanel>
    );
}
